import { Component, ElementRef, ViewChild, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import Quill from 'quill';

@Component({ standalone:false,
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent{
  @ViewChild('editor') editor!:any;
  readonly contentChanged = output<any>();
  readonly content = input.required<string>();
  readonly tagArray = input.required<string[]>();
 
  public displayTagArray: string[] = [];
  public editorContent?: string;

  constructor(private elem: ElementRef) {
    effect(() => {
      this.editorContent = this.content();
    });
    effect(() => {
      this.displayTagArray = [];
      this.tagArray()?.forEach(t => this.displayTagArray.push("[" + t + "]"));
    });
  }

  public onContentChanged(event:any){
    this.contentChanged.emit(event.html);
  }

  public onEditorCreated(quill: Quill) {
    //Update your dropdown with labels
    let placeholderPickerItems = this.elem.nativeElement.querySelectorAll('.ql-placeholder .ql-picker-item');
    placeholderPickerItems.forEach((item:any) => item.textContent = item.dataset.value);
    this.elem.nativeElement.querySelector('.ql-placeholder .ql-picker-label').innerHTML = 'Insert Custom Field &nbsp; &nbsp; &nbsp;' + this.elem.nativeElement.querySelector('.ql-placeholder .ql-picker-label').innerHTML;
  }

  get editorOptions() {
    return {
      toolbar: {
        container: [
          [{ 'size': ['small', false, 'large', 'huge'] }],          
          ['bold', 'italic', 'underline'],        // toggled buttons
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          ['link'],
          [{ 'placeholder': this.displayTagArray }] // my custom dropdown
        ],
        handlers: {
          "placeholder": function (this: any, value: string) {
            if (value) {
              const cursorPosition = this.quill.getSelection().index;
              this.quill.insertText(cursorPosition, value, 'user');
              this.quill.setSelection(cursorPosition + value.length);
            }
          }
        }
      }
    }
  }

}


